import React from "react";
import CustomBtn from "../CustomBtn/CustomBtn";
import "./stage.css";

const Stage = ({ btnText, title, subliner, list, footer }) => {
  const onHover = () => {};

  return (
    <div className="stageContainer hover-box">
      <div className="stageTitleContainer">
        <div className="stageBtn">
          <CustomBtn text={btnText} />
        </div>
        {/* title */}
        <p className="stageTitle">{title}</p>
        <p className="stageSubliner">{subliner}</p>
      </div>
      <div className="stageList">
        {list.map((item, idx) => (
          <li key={idx} className="listItem">
            <span className="listSlant">/</span>
            {item}
          </li>
        ))}
      </div>
      <div className="stageFooter">
        <p>{footer[0]}</p>
        <p className="footerR">{footer[1]}</p>
      </div>
    </div>
  );
};

export default Stage;
